// Note: this file is not exported to the rest of the package
import { normalizeSubstring } from "./helpers/normalize";
/**
 * Taken from https://lcsc.com/supplier . These are needed for exact string matches.
 * @see lcscConnector
 */
export const lcscManufacturerList = [
    "99IOT",
    "Ai-Thinker",
    "Aosong (Guangzhou) Elec",
    "ALPSALPINE",
    "AIPULNION(Guangzhou Aipu Elec Tech)",
    "AnBon",
    "Audiowell",
    "Allystar",
    "BOCHEN(Chengdu Guosheng Tech)",
    "Bothhand Enterprise",
    "BORN",
    "BROADCHIP",
    "BC(Bao Cheng Elec)",
    "Beijing Hop Tech",
    "BRIGHT",
    "baocheng(Shandong Baocheng Elec)",
    "BAT WIRELESS",
    "Changjiang Electronics Tech (CJ)",
    "CJT(Changjiang Connectors)",
    "Chengdu Ebyte Elec Tech",
    "Ckmtw(Shenzhen Cankemeng)",
    "CEC(Shenzhen Zhenhua XinYun Elec)",
    "Changzhou Huawei Elec",
    "cjiang(Changjiang Microelectronics Tech)",
    "CY(Changzhou Chaoyin Elec)",
    "Cixi Kefa Elec",
    "C&K",
    "COILANK INTERNATIONAL",
    "CHAMPION",
    "Chau Light",
    "Cross chip",
    "COV",
    "CX(Dongguan Chengxing Elec)",
    "CENKER",
    "CYBERSEN",
    "Cybermax",
    "CND-tek",
    "Chipanalog",
    "Corebai Microelectronics",
    "Chahua-Electric",
    "CJE",
    "Convert Semiconductor",
    "Cheerzing",
    "CRC",
    "Dongguan Guangzhu Industrial",
    "DIYI Elec Tech",
    "Dersonic",
    "DOWO",
    "DreamLNK",
    "DIBO",
    "dosinconn",
    "Ever Ohms Tech",
    "ENDRIVE",
    "FUDAN MICRO",
    "Foshan NationStar Optoelectronics",
    "Foshan Synwit Tech",
    "FMS(Formosa Microsemi)",
    "Foshan Blue Rocket Elec",
    "FORESEE",
    "Feng Niao RF",
    "Gotop",
    "Gainsil",
    "Guangdong Hottech",
    "GOFORD",
    "GN Semic",
    "GATEMODE",
    "GTL-POWER",
    "GOOGLL(Zhaoqing Guoju Elec)",
    "GPT",
    "GLE",
    "GOODWORK",
    "GZSJ",
    "Guo Man",
    "G-Switch",
    "HANRUN(Zhongshan HanRun Elec)",
    "HK",
    "Honor Elec",
    "HIWA",
    "Hunan Xiangyee in S&T",
    "HT(Shenzhen Jinyu Semicon)",
    "HL(Haolin Elec)",
    "HGSEMI",
    "HYP (Hongyuan Precision)",
    "HX(hengjiaxing)",
    "HenLv",
    "HOAUC",
    "HGC(Huaguan Semicon)",
    "HIECUBE",
    "Hangzhou Nanochap Electronics",
    "HUASHUO",
    "Hongda",
    "HTCSEMI",
    "ICMAN Tech",
    "INGHAi",
    "IDCHIP",
    "IIOWT",
    "Iotrda",
    "JUSHUO",
    "Jiangsu Huaneng Elec",
    "Jiangsu RUNIC Tech",
    "JCHL(Shenzhen Jing Chuang He Li Tech)",
    "Jing Extension of the Electronic Co.",
    "JGHC",
    "JESTEK",
    "Korean Hroparts Elec",
    "KIA Semicon Tech",
    "KELIKING",
    "KYET",
    "LCX(Shenzhen LCHSTAR Elec)",
    "LY",
    "LGE",
    "Leiditech",
    "LR",
    "Lanxus",
    "MDD(Microdiode Electronics)",
    "MECHANIC",
    "MindMotion Microelectronics",
    "MST",
    "MINTRON",
    "MK",
    "Milliohm",
    "Ningbo Songle Relay",
    "Ningbo Kangnex Elec",
    "NR",
    "NYBOXING",
    "ON Semiconductor",
    "PTTC(Polytronics Tech)",
    "PANASONIC",
    "PUOLOP",
    "PIP",
    "POWERBUS",
    "PROD Tech",
    "QN",
    "ROQANG",
    "RUILON(Shenzhen Ruilongyuan Elec)",
    "Reactor-Micro",
    "RI SHENG",
    "Sunlord",
    "Shenzhen JDT Fuse",
    "Shenzhen Zhihao Elec",
    "Shenzhen Sunyuan Tech",
    "Shenzhen Fuman Elec",
    "SOLA-IC",
    "Shenzhen Allvision Tech",
    "SRD(Shenzhen Sincerity Tech)",
    "SOCAY Elec",
    "Shanghai YDS Tech",
    "Shikues",
    "Shanghai Mingda Microelectronics",
    "Seaward Elec",
    "SXN(Shun Xiang Nuo Elec)",
    "SHANGHAI PUFENG OPTO ELEC TECH",
    "Shanghai Holychip Elec",
    "SINOMICON",
    "Shenzhen lanson Elec",
    "SUNLIGHT",
    "SINO-IC",
    "Slkor(SLKORMICRO Elec.)",
    "SHENZHEN ATOM TECH",
    "Shenzhen SCTF Elec",
    "Shenzhen Kinghelm Elec",
    "Shanghai Siproin Microelectronics",
    "SEMIWARE",
    "SUPER",
    "SKYPOWER",
    "SHOU HAN",
    "Sam&wing",
    "Seeed",
    "Shenzhen Yezhan Elec.",
    "SANTE",
    "Semiment",
    "SCT",
    "Shanghai Super Semiconductor",
    "SHENG FENG",
    "STEIPU",
    "TOPPOWER(Nanjing Extension Microelectronics)",
    "Techcode Semicon",
    "TECHFUSE",
    "TAE(Zhejiang Abel Elec)",
    "TTCIOTSDK(Shenzhen Shengrun Tech)",
    "TOGIALED",
    "TLC Electronic",
    "Thunder Component",
    "TyoHM",
    "TKD",
    "Trusignal Microelec.",
    "Truesemi",
    "TPOWER",
    "TONYU",
    "TWBOR",
    "UNI-ROYAL(Uniroyal Elec)",
    "UMW(Youtai Semiconductor Co., Ltd.)",
    "UMAX",
    "USAKRO",
    "VBsemi Elec",
    "VIVA",
    "Wuxi Chipown Micro-electronics",
    "WeEn Semiconductors",
    "Winsok Semicon",
    "Wuxi NCE Power Semiconductor",
    "Walter Elec",
    "Waveshare",
    "Wireless-tag",
    "Xucheng Elec",
    "XUNPU",
    "XKB Connectivity",
    "XDS",
    "Xunda",
    "XTALTQ",
    "XFCN",
    "XINLUDA",
    "XTX",
    "XSEC",
    "Yangxing Tech",
    "Yangzhou Yangjie Elec Tech",
    "Ymin",
    "yuexiang",
    "YJYCOIN",
    "Yuandi",
    "YUEXIN",
    "Yjsemi",
    "YS",
    "ZLG Zhiyuan Elec",
    "ZDAUTO",
    "ZHUHAI MONEC ELEC",
    "ZIISOR",
    "Zhejiang Fanhar",
    "3M",
    "Altera",
    "Analog Devices",
    "Alpha & Omega Semicon",
    "Advanced Monolithic Systems",
    "AVAGO(Broadcom)",
    "Alcor Micro",
    "ABLIC",
    "AVX",
    "Asahi Kasei Microdevices",
    "Allegro MicroSystems, LLC",
    "Acam Messelectronic Gmbh",
    "Amphenol ICC",
    "Adesto Technologies",
    "AEM",
    "Abracon LLC",
    "Artesyn",
    "Aavid Thermalloy",
    "AMOTECH",
    "Amphenol Aerospace",
    "Arcol",
    "Anderson Power",
    "APTIV(Delphi)",
    "Amphenol Piher",
    "ATO SOLUTION Co ., LTD",
    "Azoteq",
    "Analog Power",
    "Amphenol FCI",
    "ASR",
    "Alliance Memory",
    "ATC",
    "BUSSMANN",
    "BOURNS",
    "Broadcom Limited",
    "Bosch Sensortec",
    "Bulgin",
    "Bridgelux",
    "Cirrus Logic",
    "Cypress Semicon",
    "Central Semicon",
    "Cosmo Electronics",
    "CTS Electronic Components",
    "CREE",
    "CT Micro International",
    "CITIZEN",
    "Cantherm",
    "Comchip Technology",
    "Coilmaster Elec",
    "CREATEK",
    "CDE",
    "CINCH",
    "CDK",
    "Caddock",
    "CEVA",
    "Diodes Incorporated",
    "DAVICOM",
    "Dialog Semiconductor",
    "DecaWave",
    "Dialight",
    "DIOO",
    "DEUTSCH",
    "Detco Industries",
    "Dosilicon",
    "E-Switch",
    "Essentra",
    "Everspin Tech",
    "EPC",
    "ERNI Elec",
    "ECS",
    "ELNA",
    "EC Sense",
    "ebmpapst",
    "Fuji Electric",
    "FUJITSU",
    "FTDI",
    "FLUKE",
    "FETek",
    "Genesys Logic",
    "Grayhill",
    "HIT(Hitachi)",
    "HTC Korea TAEJIN Tech",
    "Honeywell",
    "HRS(Hirose)",
    "Heimann Sensor",
    "Holt",
    "Helix Semiconductors",
    "Intersil(Renesas Electronics)",
    "Intersil",
    "INTEL",
    "ISSI(Integrated Silicon Solution)",
    "ITT",
    "Infineon Technologies",
    "Isocom Components",
    "IKSEMICON",
    "IDEC",
    "ITT CANNON",
    "Isabellenhuette",
    "JST Sales America",
    "JAE Electronics",
    "Johanson Dielectrics",
    "KDS Daishinku",
    "KEC Semicon",
    "KEMET",
    "Kingbright",
    "Keystone",
    "Knowles",
    "Kyocera",
    "Knitter-switch",
    "KUM",
    "Kionix, Inc.",
    "Littelfuse",
    "Lattice",
    "LEM",
    "Laird-Signal(Laird Tech)",
    "Lumileds",
    "LOWPOWER",
    "Lumissil Microsystems",
    "Murata Electronics",
    "Microchip Tech",
    "Maxim Integrated",
    "Mitsumi Electric",
    "MaxLinear",
    "Mini-Circuits",
    "Micron Tech",
    "MOLEX",
    "Mitsubishi Group",
    "Melexis",
    "MCC(Micro Commercial Components)",
    "Multicomp",
    "Matsuo",
    "MINGSTAR",
    "NXP Semicon",
    "NEC",
    "Nordic Semicon",
    "Nichicon",
    "NISSEI",
    "NCC(Nippon Chemi-Con)",
    "Neutrik",
    "Nippon Tanshi",
    "Nvidia",
    "OmniVision Technologies",
    "Omron Electronics",
    "OSRAM Opto Semicon",
    "OPTEK",
    "Ogam Tech",
    "OKDO",
    "Philips Semicons",
    "Pericom/Diodes",
    "POWER INTEGRATIONS",
    "Phoenix Contact",
    "PSemi",
    "Parade Technologies",
    "Partron",
    "PNI",
    "Qualcomm(Atheros Communications)",
    "Raltron",
    "RENESAS",
    "ROHM Semicon",
    "Realtek Semicon",
    "Ramtron International Corp",
    "Recom Power",
    "Rubycon",
    "Ryazan Metal Ceramics Instrumentation Plant JSC",
    "Raspberry Pi",
    "RichWave",
    "STMicroelectronics",
    "SIEMENS",
    "Skyworks Solutions",
    "SILICON LABS",
    "Seiko Epson",
    "SPANSION",
    "Samsung Electro-Mechanics",
    "SEMTECH",
    "Synoxo",
    "Solomon Systech",
    "Sensirion",
    "SANDISK",
    "SUSUMU",
    "SCHURTER",
    "Samtec",
    "Samwha Capacitor",
    "SamYoung Electronics",
    "SSC",
    "SPS",
    "Silicon Microstructures(SMI)",
    "SparkFun Electronics",
    "SUMITOMO",
    "SUMIKO TEC.",
    "Seiko",
    "SUNGMUN",
    "SkyHigh Memory",
    "SEMITEC",
    "SFI",
    "Skygate",
    "STANDEXMEDER",
    "Samsung",
    "SENSORTEK",
    "SignalQuest",
    "SANYO DENKI",
    "TOSHIBA",
    "Texas Instruments",
    "TE Connectivity",
    "TDK",
    "Taiyo Yuden",
    "TDK InvenSense",
    "TAKAMISAWA",
    "TRINAMIC Motion Control GmbH",
    "TT Electronics",
    "Tangio",
    "TK",
    "THALES",
    "Tokmas",
    "TFSS",
    "Vishay Intertech",
    "VLSI Solution",
    "VAC",
    "VICOR",
    "WIZNET",
    "Wurth Elektronik",
    "WISOL",
    "Western Digital",
    "XILINX",
    "XMOS",
    "ZETTLER",
    "3PEAK",
    "(DIOTEC)",
    "(Weltrend)",
    "(7Q-TEK)",
    "(PUYA)",
    "3L COILS",
    "52PI",
    "2Pai Semi",
    "(JEC)",
    "嘉诚倍康",
    "华景",
    "汇顶科技",
    "APEC(Advanced Power Elec)",
    "AME",
    "Anpec Elec",
    "ASIX Elec",
    "AMS",
    "Axelite Tech",
    "Avia Semicon (Xiamen)",
    "AMAZING",
    "Allwinner Tech",
    "ABOV Semicon",
    "AMICCOM Elec",
    "AISHI(Aihua Group)",
    "AMPCOM",
    "Anaren",
    "AD Semicon",
    "ARKLED(Wuxi ARK Tech Elec)",
    "AIC(Analog Integrations)",
    "asL(Anshan Sun Locus HV Components)",
    "Arduino",
    "Apex Microtechnology",
    "AWINIC(Shanghai Awinic Tech)",
    "Ametherm",
    "APAQ Tech",
    "aptchip",
    "ACX",
    "ALLPOWER(ShenZhen Quan Li Semiconductor)",
    "ARGOSY(Argosy Research Inc.)",
    "AKER",
    "ALIENTEK",
    "Applied Power",
    "APPCON",
    "AIO",
    "AF",
    "APt",
    "Ascend",
    "AIRWAT",
    "AIHuwen",
    "ANUKI",
    "AnaSem",
    "Amicc",
    "aigo",
    "Alfa",
    "Agertech",
    "AutoChips",
    "AIDE",
    "Allyprotect",
    "BOOMELE(Boom Precision Elec)",
    "BPS(Bright Power Semicon)",
    "BL(Shanghai Belling)",
    "Brightking Elec (TAIWAN)",
    "Bojuxing Industry",
    "Bitcode",
    "Beijing Plantower",
    "BEST",
    "BYD",
    "BOYAMICRO",
    "Beijing Yu tone World Tech",
    "BL(Dongguan Bolin Elec)",
    "Bel Fuse",
    "Brightek Optoelectronics",
    "Bennic",
    "BERYL Electronic Tech",
    "Bencent",
    "Bettertree",
    "Broadic",
    "Bakon",
    "Better",
    "BASiC Semiconductor",
    "BC",
    "Benewake",
    "Bardeen Micro.",
    "BHFUSE",
    "Boarden",
    "BNstar",
    "baizou",
    "Cixi Tonver Elec",
    "ChipLink Tech",
    "Changzhou Starsea Elec",
    "Chilisin Elec",
    "CHIPSEA",
    "Capxon International Elec",
    "CET(Chino-Excel Tech)",
    "Coilcraft",
    "California Eastern Laboratories",
    "CONNFLY Elec",
    "Chengdu Ashining Tech",
    "Changzhou Amass Elec",
    "CONCRAFT",
    "CEC(Shenzhen Zhenhua Fu Elec)",
    "Cmedia",
    "Chiphom",
    "CCO(Chian Chia Elec)",
    "CHINT",
    "Carli",
    "Chinamobile",
    "Cyntec",
    "CORPRO",
    "CoreChips",
    "Cvilux",
    "Chipone Tech",
    "CHENMKO ENTERPRISE",
    "CYGWAYON",
    "CEC",
    "CCTC",
    "CZT",
    "Cmsemicon",
    "Chip-lead",
    "CanaanTek",
    "CONQUER",
    "Chongqing Pingwei Tech",
    "Cha",
    "CENGOL",
    "Cellwise",
    "CNJM",
    "CYSTECH",
    "COILMX",
    "CETC",
    "CRMICRO",
    "CNIBAO",
    "CKS",
    "CHIPLON",
    "Chip-Rail",
    "COSEMITECH",
    "CHIPWISE",
    "Celfras",
    "Chinocera",
    "Chiplntelli",
    "Consensic",
    "CCB",
    "CHI Power",
    "Ceaiya",
    "COREX",
    "CONNTEK",
    "CNR",
    "COSINE",
    "Churod Electronics",
    "CAX",
    "CASS",
    "Chuanjing Tech.",
    "Cocentra",
    "Creat Storage World",
    "CORETONG",
    "Changjiang",
    "CBI",
    "CHEVRON",
    "Diptronics",
    "Daily Silver Imp Microelectronics",
    "Dongwoon Anatech",
    "Dongguan Salipt",
    "Delixi Electric",
    "Dinkle",
    "Delta Elec",
    "Dynastream Innovations",
    "Dongguan Mentech Optical & Magnetic",
    "Darfon Elec",
    "DAIN Elec",
    "DIOFIT Tech",
    "DEFOND",
    "DC(DongChen)",
    "DESAY",
    "DC",
    "Dailywell",
    "DreamSourceLab",
    "DEGSON",
    "DLK",
    "DEXU Electronics",
    "Doeshare",
    "DGBZ",
    "DMBJ",
    "DMEGC",
    "DECON",
    "D-SWITCH",
    "Everlight Elec",
    "Eutech Microelectronics",
    "EIC Semicon",
    "EG Micro",
    "Espressif Systems",
    "ECE",
    "Epticore Microelectronics (Shanghai)",
    "ELAN Microelectronics",
    "Everanalog IC design",
    "EYANG(Shenzhen Eyang Tech Development)",
    "ESMT(Elite Semicon Memory Tech)",
    "EATON",
    "E-youda",
    "EMTEK",
    "ECEC(ZheJiang E ast Crystal Elec)",
    "Everest-semi(Everest Semiconductor)",
    "EKINGLUX",
    "ECT",
    "EMC",
    "Efinix",
    "EasyDetek",
    "Enicom",
    "Elrigs",
    "E-T-A",
    "ESHION",
    "ETERNAL",
    "EXTREME POWER",
    "ehiway",
    "FH(Guangdong Fenghua Advanced Tech)",
    "Fortune Semicon",
    "Feeling Tech",
    "Fitipower Integrated Tech",
    "First Semicon",
    "Fortior Tech",
    "Firstohm(First Resistor & Condenser)",
    "Futaba Elec",
    "Fair-Rite Products",
    "FH-BK(Guangdong Fenghua Bangke Elec)",
    "FMD(Fremont Micro Devices)",
    "Fuzetec Tech",
    "FOXCONN",
    "FORT",
    "FH-LH.Nova",
    "FUET",
    "Fengming",
    "FeiHong",
    "FATRI",
    "FTR",
    "FPE",
    "FSHY",
    "FUXINSEMI",
    "FSP",
    "FIBOCOM",
    "FST",
    "FG",
    "FSD-CON",
    "GMT(Global Mixed-mode Tech)",
    "GigaDevice Semicon Beijing",
    "Guangzhou Huanghua Elec",
    "Guoguang Elec Sci-tech",
    "Guangzhou Dtech Elec Tech",
    "GoChip Elec Tech (Shanghai)",
    "Gosuncn",
    "GUERTE(Zhejiang Guchi Elec)",
    "Generalplus",
    "Gotrend Tech",
    "GOODSKY",
    "Guangdong TOPAZ Elec Tech",
    "GORDAK",
    "GANGYUAN",
    "GD",
    "Giantec",
    "Goertek",
    "GW",
    "Guangzhou Jingyou Electronic Tech",
    "GP(GreenPower)",
    "Galaxy",
    "Geehy",
    "GuangZhou YiHua Electronic",
    "GSTEK(Green Solution Technology)",
    "Greenliant",
    "Grenergy",
    "GXCAS",
    "Gantong",
    "Gcore",
    "GMA",
    "GDHY",
    "GBG",
    "GEPU",
    "Guestgood",
    "GUOXIN JIAPIN SEMICONDUCTOR",
    "GEC",
    "Hubei KENTO Elec",
    "Hangzhou Silan Microelectronics",
    "HF(Xiamen Hongfa Electroacoustic)",
    "Hua Hong NEC",
    "HTV(Ningbo Bo Yue Elec)",
    "Holtek Semicon",
    "HopeRF Micro-electronics",
    "HiTrend Tech (Shanghai)",
    "HYCON Tech",
    "Hiliwei Tech",
    "HY Elec",
    "Hosonic Elec",
    "HR(Joint Tech Elec)",
    "Haoyu Microelectronics",
    "Hangzhou Ruimeng Tech",
    "Hongzhi Elec",
    "Hsin Da Precision",
    "HDK(Hokuriku Elec Industry)",
    "HELE(Harmony Elec)",
    "HARVATEK",
    "HKR(Hong Kong Resistors)",
    "Hk-hotline",
    "HEXIN",
    "HX(Zhejiang Yueqing Hongxing Elec)",
    "HI-LINK",
    "Hammond",
    "HONGLITRONIC(Hongli Zhihui (HONGLITRONIC))",
    "HEADCON",
    "HENIPER",
    "HOOYA",
    "HONGJU",
    "HUAYING",
    "Hichips",
    "HUAYI",
    "Hercules-micro",
    "HOLLY",
    "HUAWEI",
    "HEAO",
    "Hanbo Electronic",
    "HS(H asion Electronics)",
    "HCI",
    "High Diode",
    "HD  SHOULDER",
    "HOZONOVO",
    "HUAXIN",
    "Heling",
    "Hexawave",
    "HUI JU",
    "HXT",
    "HUAKE",
    "HYPWR",
    "HVDIODE",
    "HD",
    "HF",
    "HAIGU",
    "HEERMICR",
    "Huaxing Mechanical-Elec.",
    "Hosin Global",
    "HANGZHI",
    "HRH",
    "HYHONGYEX",
    "Hongzhi Forest",
    "HJ Tech",
    "HINOVAIC",
    "HYNCDZ",
    "Hong Sui",
    "IXYS",
    "IC Plus",
    "iC-Haus GmbH",
    "Iflytek",
    "IHHEC(HOLY STONE ENTERPRISE CO., LTD)",
    "IPS",
    "INJOINIC",
    "INPAQ",
    "IRONCHIP",
    "ISMARTWARE",
    "IRdopto",
    "ICORE",
    "iCM",
    "Ingenic",
    "Innosen",
    "ISND",
    "JRC",
    "Jiaxing Heroic Elec Tech",
    "Jilin Sino-Microelectronics",
    "Jiangsu JieJie Microelectronics",
    "JoulWatt Tech",
    "Jixin",
    "Jinlai",
    "JILN",
    "Jinrui Electronic Materials Co.",
    "JETEKPS",
    "JEC",
    "Jimson",
    "JINLANG",
    "JH",
    "JX",
    "Just Right",
    "JYJE",
    "JF",
    "JINJIA",
    "JSMSEMI",
    "JWT",
    "JWD",
    "JUNSHINE",
    "JSY-KJ",
    "JIERONG",
    "JU YONG CHANG",
    "JASN",
    "JD",
    "JAFLY",
    "KOA Speer Elec",
    "Kodenshi",
    "KST(K.S Terminals)",
    "Kodenshi AUK",
    "KET",
    "KSS(KAI SUH SUH ENTERPRISE)",
    "KIWI",
    "KAMAYA",
    "KYX",
    "KEXIN",
    "KS",
    "Kailh",
    "Keysemi",
    "Kingston Technology",
    "KNSCHA",
    "Kemit",
    "Kingcore",
    "KINETIC",
    "KFSON",
    "KOHERelec",
    "KIOXIA",
    "KAIFENG",
    "KINGSTATE",
    "KY",
    "KOTL",
    "Kinghor",
    "KCT",
    "Lite-On",
    "LRC",
    "LCSC",
    "Leadtrend Tech",
    "Longtech Optics",
    "LinkCoreSafe",
    "LONGSUNG",
    "LYNQ(Shanghai Mobiletek Communication)",
    "LEDdynamics",
    "Lelon",
    "LIZ Elec",
    "LADDER Elec",
    "LOTES",
    "Lyontek Inc.",
    "LITEON",
    "Legion",
    "Lansus",
    "Lextar",
    "LX",
    "Longkingdom",
    "LTKCHIP",
    "LEANSTAR",
    "LONTEN",
    "Liown",
    "LSD",
    "lipoo",
    "LEADCHIP",
    "LOONGSON",
    "Leading Energy",
    "LINKOSEMI",
    "Liansheng",
    "LNLON",
    "LEADER",
    "LANKE",
    "Letex",
    "Made in China",
    "MA/COM",
    "MATSUKI",
    "MICRONE(Nanjing Micro One Elec)",
    "Megawin Tech",
    "MORNSUN Guangzhou S& T",
    "Meled",
    "MBI",
    "Microsemi",
    "MAXIC Tech",
    "MW(MEAN WELL Enterprises)",
    "MEMSIC",
    "Metrodyne Microsystem",
    "Mixic",
    "MagnaChip Semicon",
    "MXIC(Macronix)",
    "MST(Magnesensor Tech (MST))",
    "METZ CONNECT GmbH",
    "Man Yue Tech",
    "MOSPEC Semicon",
    "Maxscend",
    "MAZO",
    "microgate",
    "Mersen",
    "MAGLAYERS",
    "Megapower",
    "Magsonder",
    "MEIHUA",
    "MIXINNO",
    "Me-TECH",
    "Maplesemi",
    "MINEW",
    "M3TEK",
    "Meatrol",
    "MYIR",
    "MACHINE INTELLIGENCE",
    "Magn Tek",
    "MYOUNG",
    "MEMS",
    "Matrix Opto",
    "MSKSEMI",
    "Mysentech",
    "Nuvoton Tech",
    "Ningbo Keke New Era Appliance",
    "NDK",
    "Nanjing Zhongke Microelectronics",
    "Nanjing Shiheng Elec",
    "Nidec",
    "NST Tech",
    "Nanjing Ouzhuo Tech",
    "Ningbo SUPU Elec",
    "NATLINEAR",
    "Nextron(Nextronics Engineering)",
    "Nexperia",
    "Nanjing AH Elec S & T",
    "NVE",
    "Nidec Copal Elec",
    "NIKO Semicon",
    "Nanya Tech",
    "NF(Ningbo Forward Relay Corp)",
    "Nantong Jianghai Capacitor",
    "NanJing ZhongXu Elec",
    "NKK Switches",
    "Nistronics",
    "NUTECH",
    "NBC",
    "NHLC",
    "NOVOSENSE",
    "NAMAE",
    "Ningbo Xinlaiya Elec.",
    "NengDrive",
    "NEOTEC",
    "NDF",
    "NOXTLON",
    "NEWOPTO",
    "NDST",
    "OB(On-Bright Elec)",
    "Ohmite",
    "Orient",
    "On-Shore Tech",
    "OptoSupply",
    "OASIS",
    "OCIC",
    "OPENNCC",
    "ORIENTAL SEMI",
    "OCX",
    "Prolific Tech",
    "PTC(Princeton Tech)",
    "Pulse Elec",
    "PAN CHANG",
    "PAM(Diodes Inc)",
    "PowTech(CR-PowTech(Shanghai))",
    "ProTek Devices",
    "PANJIT International",
    "Prokit's Industries",
    "Peng Cheng Hardware Plastic Products",
    "PSA(Prosperity Dielectrics)",
    "PADAUK Tech",
    "PowerSync International",
    "Panchip Microele",
    "PFC Device",
    "PN SILICON",
    "Potens",
    "PINREX",
    "PJSEMI",
    "PowerGood",
    "phaetonsemi",
    "PARALIGHT",
    "PPT",
    "POWLICON",
    "PLT",
    "PEAKCOO",
    "PowerWriter",
    "prosemi",
    "powersilicon",
    "Q&J",
    "QX Micro Devices",
    "Qingxian Zeming Langxi Elec",
    "Quectel",
    "QUICK",
    "Qingdao Eastsoft Communication Tech",
    "Qorvo",
    "QST",
    "QAMcn",
    "QIACHIP",
    "RALEC",
    "Richtek Tech",
    "Ricoh Elec Devices",
    "RDA Microelectronics",
    "RAIO Tech",
    "RONGHE Microelectronics",
    "RENERGY",
    "RZ(Wuxi Smart Microelectronics)",
    "Rainsun microwave Tech",
    "RFsister",
    "Rockchip",
    "ROCKTEK",
    "Resistor.Today",
    "ROFS",
    "RC(Suzhou Ruikong Microelec)",
    "RYCHIP Semiconductor Inc.",
    "RFIC",
    "RAYMAX",
    "Runjet",
    "rlt",
    "RIVER",
    "ROSWIN",
    "RCH",
    "RGB-Tech",
    "REASUNOS",
    "RF Crazy",
    "ROCPU",
    "Reomax",
    "ruidakangDY",
    "RECTRON",
    "Rayson",
    "SHXCC",
    "Shenzhen JIALICHUANG Elec Tech Dev.",
    "SOC(Shenzhen SinOne Microelectronics)",
    "Sharp Microelectronics",
    "STC Micro",
    "ST(Semtech)",
    "SK HYNIX",
    "SGMICRO",
    "SiTime",
    "SEMICO",
    "SANLUX(Sanyo Semicon)",
    "ShangHai Consonance Elec",
    "SIMCom Wireless Solutions",
    "Sanken Elec",
    "SUP",
    "SX(Shenzhen Suosemi Tech)",
    "SHOUDING",
    "SONIX",
    "Shenzhen DongKe Semicon",
    "Senba Sensing Tech",
    "Silergy Corp",
    "Shenzhen Sunmoon Micro",
    "Shanghai Nicera Sensor",
    "Sigma Micro",
    "Sinopower Semicon",
    "Sumida",
    "Suzhou Good-Ark Elec",
    "Song Chuan",
    "Shenzhen ruichips Semicon",
    "Sillumin",
    "Sata Tools(ShangHai)",
    "Shenzhen Better Life Elec S&T",
    "Shenzhen Woer Heat-Shrinkable Material",
    "SUNON(Sunonwealth Elec Machine Industry)",
    "Shenzhen Chip Hope Micro-Electronics",
    "Schneider",
    "Shenzhen Yspring Tech",
    "Shiningic",
    "Shandong Jingdao Microelectronics",
    "SUNMATE Elec",
    "Shanghai Prisemi Elec",
    "SOFNG",
    "SMC(Sangdest Microelectronicstronic (Nanjing))",
    "Shenzhen FAST Sensors",
    "Sequoia Microelectronics",
    "Shenzhen Glgnet Elec",
    "Sullins Connector Solutions",
    "Shanghai Elinker Elec",
    "Shenzhen CMOSIC intelligent",
    "Silicon Wisdom Tech",
    "Sinowealth",
    "Simware",
    "Si-power",
    "Sunltech Tech",
    "SUNCON(SUN Elec Industries)",
    "SART(Nanjing Sart Tech)",
    "SHINYEI",
    "Shenzhen Nsiway Tech",
    "SEI(Stackpole Elec)",
    "Sensata Tech",
    "SIWARD",
    "SANKOSHA",
    "STE(Songtian Elec)",
    "Suzhou Liming Elec",
    "SJK(SHENZHEN CRYSTAL TECH)",
    "Shenzhen Haoruijia Elec.",
    "SMK Corp.",
    "Schaffner",
    "SamHop Microelectronics Corp.",
    "Southchip Semicon",
    "SANYOU RELAYS",
    "Sifirst",
    "Semitel",
    "Shinmei",
    "SIT",
    "Su'scon",
    "SHM",
    "Siliconmitus(Silicon Mitus)",
    "Shenzhen Jinkaisheng Elec",
    "Shuntian",
    "S&S",
    "SANYEAR",
    "Samwin",
    "SI",
    "SHMICTRL",
    "SINOFUSE",
    "SemiHow",
    "Starpower",
    "Silicore",
    "Sf",
    "SPTECH",
    "SENASIC",
    "Shenzhen Developer Microelec.",
    "STWXE",
    "Sinai Power",
    "SURGING",
    "SHINKI",
    "Silicon Billion",
    "Sine Microelectronics",
    "SDC",
    "SHI AO FENG",
    "SEMBO",
    "Starwave",
    "SALLTECH",
    "Suntek",
    "STANSON Tech.",
    "SS lnnovation Precision Hardware",
    "SM Switch",
    "SteadiChips",
    "SK Electronic",
    "SOREDE",
    "SUPCON MICROELECTRONICS",
    "Silverlight",
    "SHORI",
    "TXC Corp",
    "Torex Semicon",
    "TENTA ELEC INDUSTRIAL",
    "Terminus Tech",
    "TM(Shenzhen Titan Micro Elec)",
    "TAI-TECH",
    "TORCH",
    "Tontek Design Tech",
    "Taiwan Semiconductor(Taiwan Semicon)",
    "TKS",
    "Tak Cheong",
    "TA-I Tech",
    "TAITIEN Elec",
    "Tokyo Cosmos Elec",
    "Teapo Elec",
    "TANCAP Tech",
    "THine Elec",
    "TNK",
    "THX",
    "Tongfeng",
    "THD",
    "TOPPOWER",
    "TST",
    "Taisko",
    "TDG",
    "TuoFeng",
    "TXGA",
    "TMI",
    "Temile",
    "TECH PUBLIC",
    "TDPOWER",
    "TUOZHAN",
    "TECONN",
    "TPS",
    "TWGMC",
    "TDK-LAMBDA",
    "TCWIN",
    "TF",
    "TESL*A",
    "TRX",
    "Toponelec",
    "TUYA",
    "TZL",
    "UTC(Unisonic Tech)",
    "Uni-Trend Tech",
    "UG(Univision Semicon)",
    "uPI Semiconductor",
    "U-NIK",
    "USR IOT",
    "UDE Corp",
    "UNI-SEMI",
    "UNEO",
    "Union Semiconductor",
    "UTX",
    "Ubibot",
    "UNITED",
    "UN",
    "Viking Tech",
    "VICTOR(Double King Industrial Holdings)",
    "VIA Tech",
    "Vilsion Tech",
    "VDR   Varistor",
    "VT(Vertical Technology)",
    "VP",
    "Vanguard",
    "VIIYONG",
    "VOLTAIC",
    "VIBRATION",
    "VTran Tech",
    "VSS",
    "Vollgo",
    "VCHIP",
    "VISOM",
    "WCH(Jiangsu Qin Heng)",
    "Winbond Elec",
    "WILLSEMI(Will Semicon)",
    "WENTAI",
    "Walsin Tech Corp",
    "Wuxi I-core Elec",
    "WEIKAI",
    "WT(Guangzhou Wei Chuang Elec)",
    "WIMA",
    "WAGO",
    "Wuxi Siyon Microelectronics Tech",
    "Worldsemi",
    "Wuxi China Resources Huajing Microelectronics",
    "Winday Elec",
    "WPMtek(Wei Pan Microelectronics)",
    "Wuxi ETEK Microelectronics",
    "WRG(Wangrong)",
    "WQC",
    "WiseChip",
    "WUXI UNIGROUP MICRO",
    "Winsemi",
    "WISDOM",
    "Wenshan",
    "WEIPU",
    "WinnerMicro",
    "Winchen",
    "WMEC",
    "Wayon",
    "WANJIE",
    "WL",
    "WIER",
    "Wcon",
    "WTL",
    "wisesun",
    "World",
    "WONDHOPE ELECTRIC",
    "XLSEMI",
    "XPT(Shenzhen XPTEK Tech)",
    "XIAMEN FARATRONIC",
    "XySemi",
    "XI'AN Aerosemi Tech",
    "Xi'an NSDZ-Tech",
    "XIAOCHENG",
    "XSD",
    "XMC",
    "XINER",
    "Xx(Xingxin sci-tech)",
    "XTY",
    "XINGUAN",
    "XINGLIGHT",
    "Xinchangzheng",
    "XDM",
    "YAGEO",
    "Yunxing",
    "Yazaki (China) Investment",
    "YUXIN TECH",
    "YUEN FUNG",
    "YL(Failong Crystal)",
    "Yongyu Photoelectric",
    "Yanchuang",
    "YW",
    "Yint",
    "YCT Elec",
    "YUANZE RELAY",
    "YTL",
    "YFW",
    "YXT",
    "Zhejiang HKE",
    "ZHONGKEWEI",
    "Zilog",
    "Z-TEK",
    "Zhengzhou Winsen Elec Tech",
    "ZOWIE Tech",
    "ZLFY",
    "ZILLTEK",
    "ZOUGUANG",
    "Zeasset",
    "Zentel",
    "Zbit Semi",
    "Zisenisc",
    "Zhaoqing Ruilong Elec.",
    "ZRE",
    "ZHONGCHI ELECTRONIC",
    "Zetta",
    "Zeng Yi",
    "ZHIDE",
];
export const lcscManufacturerListLowercase = Object.fromEntries(lcscManufacturerList.map((name) => [name.toLowerCase(), name]));
// It's not clear whether LCSC filter accepts more than a single ID, so we take the shortest name match
export function lcscManufacturerIdBySubstring(substring) {
    substring = normalizeSubstring(substring);
    const names = lcscManufacturerList
        .filter((name) => name.toLowerCase().includes(substring))
        .sort((a, b) => a.length - b.length);
    return names[0];
}
//# sourceMappingURL=lcscManufacturerList.js.map